// withAuth.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import LoginPage from '.';

const withAuth = (WrappedComponent) => {
  return (props) => {
    const navigate = useNavigate();
    const isAuthenticated = Boolean(sessionStorage.getItem('authToken'));

    if (!isAuthenticated) {
      navigate('/login');
      return <LoginPage/>;
    }

    return <WrappedComponent {...props} />;
  };
};

export default withAuth;
